import { restaurantPropTypes } from '@nandosaus/prop-types';
import { MARKET } from '@nandosaus/constants';
import React from 'react';
import { useFeature } from '@hooks/use-feature';

import { Button } from '../button/new';
import { Flex } from '../grid';
import { navigation } from '../../constants';
import { StyledContainer } from '../content-image/styles';
import { useMarket } from '../../hooks/use-market';

const RestaurantOrderButton = ({ restaurant }) => {
  const { isOpen, id, orderingEnabled, cateringEnabled } = restaurant;
  const market = useMarket();
  const isAustralianMarket = market === MARKET.AUSTRALIA;

  const isRestaurantOpenAndTakeOrders = !!(orderingEnabled && isOpen);

  const comingSoonRestaurants = useFeature('coming-soon-restaurant-whitelist');
  const comingSoon = comingSoonRestaurants?.restaurantIds?.includes(parseInt(restaurant.id, 10)) || false;

  return !comingSoon || isRestaurantOpenAndTakeOrders ? (
    <StyledContainer>
      <Flex flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" justifyContent="center">
        <Flex gap="16px">
          <Button
            disabled={!isRestaurantOpenAndTakeOrders}
            variant="primary"
            size="tall"
            {...(isRestaurantOpenAndTakeOrders && {
              href: {
                pathname: navigation.MENU,
                query: { r: id, showAllOrderTypes: true },
              },
            })}
          >
            Order Online
          </Button>
          {cateringEnabled && isAustralianMarket && (
            <Button
              variant="quaternary"
              size="tall"
              disabled={!orderingEnabled}
              {...(orderingEnabled && {
                href: {
                  pathname: navigation.CATERING,
                  query: { r: id, showAllOrderTypes: true },
                },
              })}
            >
              Order Catering
            </Button>
          )}
        </Flex>
      </Flex>
    </StyledContainer>
  ) : null;
};

RestaurantOrderButton.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
};
export { RestaurantOrderButton };
